import Urls from './globel.js'
import Vue from 'vue'
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

// export function getSitesEditorModuleStateKey(prefix, moduleProp) {
//   return `${prefix}_${moduleProp.type}_${moduleProp._id}`
// }
export function getSitesEditorModuleStateKey(prefix, moduleProp) {
  return `${prefix}_${moduleProp.itemType}_${moduleProp.id}`
}
export function getItemStateKey(prefix, id) {
  return `${prefix}_${id}`
}
export function mapObj(theMap, data, isRevert = false) {
  const newData = {}
  if (isRevert) {
    for (const key in data) {
      newData[theMap[key]] = data[key]
    }
  } else {
    for (const key in theMap) {
      newData[key] = data[theMap[key]]
    }
  }
  return newData
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = s => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function converBToMb(fileSize) {
  let size = ''
  if (fileSize < 0.1 * 1024) {
    size = fileSize.toFixed(2) + 'B'
  } else if (fileSize < 0.1 * 1024 * 1024) {
    size = (fileSize / 1024).toFixed(2) + 'KB'
  } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
    size = (fileSize / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
  const sizestr = size + ''
  const len = sizestr.indexOf('.')
  const dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

export function transformUrl(url) {
  if (url.startsWith('http')) {
    return url
  }
  if (!url.startsWith('/')) {
    url = '/' + url
  }
  // return process.env.VUE_APP_OBS_URL + process.env.VUE_APP_OBS_FOLDER_NAME + url
  return process.env.VUE_APP_OBS_URL + url
}
// 链接地址判断，是否含有http或者https
export function checkUrl(url) {
  if (url) {
    // 判断是否符合http://符合返回真不符合返回假
    const http = /^http:\/\/.*/i.test(url)
    // 判断是否符合https://符合返回真不符合返回假
    const https = /^https:\/\/.*/i.test(url)
    // 如果两个都为假，我们就为客户添加http://
    if (!http && !https) {
      url = 'http://' + url
    } else {
      return true
    }
    return url
  }
}
// 如果要确保函数只执行一次的情况
export function onceEvent(fn) {
  let called = false
  return function () {
    if (!called) {
      called = true
      fn.apply(this, arguments)
    }
  }
}

// json转换url参数
export function parseParam(param = {}) {
  const defaultData = Vue.ls.get('loginInfo') || {}
  const target = Object.assign(defaultData, param)
  const data = Object.keys(target).map(function (key) {
    if (Array.isArray(target[key]) || target[key] instanceof Object) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(target[key]))
    } else {
      return encodeURIComponent(key) + '=' + encodeURIComponent(target[key])
    }
  }).join('&')
  return data
}

/**
 * 拼接 视频地址  数据格式错返回null
 * @param videoId
 * @param video
 */
export function transformVideoUrl(videoId, video) {
  const videoUrl = null
  if (video !== null && videoId !== undefined) {
    if (video.pu !== undefined && video.timestamp !== undefined && video.format !== undefined && video.sign !== undefined) {
      return Urls.getVideoPrefix + '&videoId=' + videoId +
        '&pu=' + video.pu + '&timestamp=' + video.timestamp + '&format=' + video.format + '&sign=' + video.sign + '&df=3'
    }
  }
  return videoUrl
}

/**
 * components util
 */

/**
 * 清理空值，对象
 * @param children
 * @returns {*[]}
 */
export function filterEmpty(children = []) {
  return children.filter(c => c.tag || (c.text && c.text.trim() !== ''))
}

export const searchData = (result) => {
  const param = {
    showCount: 1,
    currentPage: 1,
  }
  if (result) {
    const num = parseInt(result, 10)
    if (!isNaN(num)) {
      param['code'] = result
    } else {
      param['name'] = result
    }
  }
  return param
}

// 判断空对象 true为空对象
export function checkObjectOfNull(data) {
  const flag = (JSON.stringify(data) === '{}')
  return flag
}

/**
 * 数字保留两位小数
 * @param num
 */

export function keepTwoDecimalFull(num) {
  if (isNaN(num)) {
    return
  }
  num = Math.round(num * 100) / 100
  let sx = num.toString()
  let posdecimal = sx.indexOf('.')
  if (posdecimal < 0) {
    posdecimal = sx.length
    sx += '.'
  }
  while (sx.length <= posdecimal + 2) {
    sx += '0'
  }
  const n = parseFloat(sx)
  return n
}

export function isUndef(v) {
  return v === undefined || v === null
}

export function isDef(v) {
  return v !== undefined && v !== null
}

/**
 * 获取背景数据信息
 * @param bgId 背景单据Id
 */
export function getBgTataData(bgId) {
  const bgData = Vue.ls.get(`KP_BGDATA_${bgId}`)
  return bgData
}

/**
 * 存放背景单据信息
 * @param bgId
 */
export function putBgTataData(bgId, bgData) {
  Vue.ls.remove(`KP_BGDATA_${bgId}`)
  if (bgData) {
    Vue.ls.set(`KP_BGDATA_${bgId}`, bgData)
  }
}

/**
 * 数字转换成中文
 */
export function changeNumMoneyToChinese(number) {
  const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'] // 汉字的数字
  const cnIntRadice = ['', '拾', '佰', '仟'] // 基本单位
  const cnIntUnits = ['', '万', '亿', '兆'] // 对应整数部分扩展单位
  const cnDecUnits = ['角', '分', '毫', '厘'] // 对应小数部分单位
  const cnInteger = '整' // 整数金额时后面跟的字符
  const cnIntLast = '圆' // 整型完以后的单位
  const maxNum = 999999999999999.9999 // 最大处理的数字
  let IntegerNum // 金额整数部分
  let DecimalNum // 金额小数部分
  let ChineseStr = '' // 输出的中文金额字符串
  let parts // 分离金额后用的数组，预定义
  let Symbol = '' // 正负值标记
  if (number === '') {
    return ''
  }
  number = parseFloat(number)
  if (number >= maxNum) {
    alert('超出最大处理数字')
    return ''
  }
  if (number === 0) {
    ChineseStr = cnNums[0] + cnIntLast + cnInteger
    return ChineseStr
  }
  if (number < 0) {
    number = -number
    Symbol = '负 '
  }
  number = number.toString() // 转换为字符串
  if (number.indexOf('.') === -1) {
    IntegerNum = number
    DecimalNum = ''
  } else {
    parts = number.split('.')
    IntegerNum = parts[0]
    DecimalNum = parts[1].substr(0, 4)
  }
  if (parseInt(IntegerNum, 10) > 0) { // 获取整型部分转换
    let zeroCount = 0
    const IntLen = IntegerNum.length
    for (let i = 0; i < IntLen; i++) {
      const n = IntegerNum.substr(i, 1)
      const p = IntLen - i - 1
      const q = p / 4
      const m = p % 4
      if (n === '0') {
        zeroCount++
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0]
        }
        zeroCount = 0 // 归零
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
      }
      if (m === 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q]
      }
    }
    ChineseStr += cnIntLast
    // 整型部分处理完毕
  }
  if (DecimalNum !== '') { // 小数部分
    const decLen = DecimalNum.length
    for (let i = 0; i < decLen; i++) {
      const n = DecimalNum.substr(i, 1)
      if (n !== '0') {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i]
      }
    }
  }
  if (ChineseStr === '') {
    ChineseStr += cnNums[0] + cnIntLast + cnInteger
  } else if (DecimalNum === '') {
    ChineseStr += cnInteger
  }
  ChineseStr = Symbol + ChineseStr
  return ChineseStr
}
